import { Typography } from '@material-ui/core';
import { Stack } from '@superdispatch/ui';
import { PaymentInfo } from 'shared/ui/PaymentInfo';
import { PostingLoadDTO } from '../data/dto/PostingLoadDTO';
import { PostingDistancePriceDetails } from './PostingDistancePriceDetails';

interface Props {
  load: PostingLoadDTO;
  source?: 'Load Details' | 'Load List' | 'Suggested Load';
  showDistancePriceDetails?: boolean;
}

export function PostingPaymentDetails({
  load,
  source,
  showDistancePriceDetails = true,
}: Props) {
  const { payment } = load;

  return (
    <Stack space="xxsmall">
      <Typography aria-label="payment info" noWrap={true}>
        <PaymentInfo
          terms={payment.terms}
          method={payment.method}
          source={source}
        />
      </Typography>

      {showDistancePriceDetails && <PostingDistancePriceDetails load={load} />}
    </Stack>
  );
}
